import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import type { PlgAnticipationResponse } from 'v2/interfaces/plgAnticipation';
import plgAnticipationService from 'v2/services/plgAnticipation';

export function useGetPlgAnticipation(
  options: Omit<UseQueryOptions<PlgAnticipationResponse>, 'queryKey' | 'queryFn'> = {}
) {
  return useQuery({
    queryKey: ['plgAnticipation'],
    queryFn: () => plgAnticipationService.getPlgAnticipation(),
    ...options
  });
}

export function usePlgSaveAccess(options: UseMutationOptions<void, unknown, string> = {}) {
  return useMutation({
    mutationFn: async (screen: string) => plgAnticipationService.plgSaveAccess(screen),
    ...options
  });
}
